<script>
import CandidateCard from '@/components/candidate/candidate-card.vue'
import accessibleNavigationMixin from '@/mixins/accessibleNavigationMixin'

export default {
  name: 'CandidateList',
  components: { CandidateCard },
  mixins: [accessibleNavigationMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
    pageNumber: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
}
</script>

<template>
  <div class="candidate-list">
    <v-row @keydown="onAccNavKeydown">
      <v-col
        v-for="(candidate, index) in items"
        :key="`candidate-${candidate.candidateId}`"
        cols="12"
        sm="6"
        md="4"
        xl="3"
      >
        <CandidateCard
          ref="accNavItems"
          :candidate="candidate"
          :tabindex="index === accNavFocusedIndex ? 0 : -1"
          @view-candidate="$emit('view-candidate', $event)"
          @preference-updated="$emit('preference-updated')"
        />
      </v-col>
    </v-row>

    <transition
      name="fade"
      enter-active-class="fade-enter-active candidate-list__pagination-enter-delay"
    >
      <div v-if="totalPages > 1" class="d-flex justify-center mt-6">
        <v-pagination
          :value="pageNumber"
          class="candidate-list__pagination"
          color="primary"
          :length="totalPages"
          :total-visible="7"
          @input="$emit('go-to-page', $event)"
        />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_vue-transitions.scss';
@import '@/styles/_colors.scss';
</style>

<style lang="scss">
@import '@/styles/candidate/candidate-list-pagination.scss';

.candidate-list__pagination-enter-delay {
  transition-delay: 0.6s;
}
</style>
